import axios from "axios";
import config from "../../config/config";
import Cookie from "cookies-js";


export const Manage_consent_service = {
    getTermsAndCondition,
    saveTermsAndCondition,
    getPrivacy,
    savePrivacy,
    getSecurity,
    saveSecurity,
    getCookie,
    saveCookie
};

function getTermsAndCondition(){
    // let user_nbtc = Cookie.get('user_nbtc')
    // let json_cookie = JSON.parse(user_nbtc);
    return new Promise((resolve, reject) => {
        axios.post(config.API_URL + "consent/getTermsAndCondition")
            .then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
    })
}

function saveTermsAndCondition(data){
    let user_nbtc = Cookie.get('user_nbtc')
    let json_cookie = JSON.parse(user_nbtc);
    return new Promise((resolve, reject) => {
        axios.post(config.API_URL + "consent/saveTermsAndCondition/?authorization=" + json_cookie.token, data)
            .then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
    })
}

function getPrivacy(){
    return new Promise((resolve, reject) => {
        axios.post(config.API_URL + "consent/getPrivacy")
            .then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
    })
}

function savePrivacy(data){
    let user_nbtc = Cookie.get('user_nbtc')
    let json_cookie = JSON.parse(user_nbtc);
    return new Promise((resolve, reject) => {
        axios.post(config.API_URL + "consent/savePrivacy/?authorization=" + json_cookie.token, data)
            .then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
    })
}

function getSecurity(){
    return new Promise((resolve, reject) => {
        axios.post(config.API_URL + "consent/getSecurity")
            .then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
    })
}

function saveSecurity(data){
    let user_nbtc = Cookie.get('user_nbtc')
    let json_cookie = JSON.parse(user_nbtc);
    return new Promise((resolve, reject) => {
        axios.post(config.API_URL + "consent/saveSecurity/?authorization=" + json_cookie.token, data)
            .then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
    })
}

function getCookie(){
    return new Promise((resolve, reject) => {
        axios.post(config.API_URL + "consent/getCookie")
            .then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
    })
}

function saveCookie(data){
    let user_nbtc = Cookie.get('user_nbtc')
    let json_cookie = JSON.parse(user_nbtc);
    return new Promise((resolve, reject) => {
        axios.post(config.API_URL + "consent/saveCookie/?authorization=" + json_cookie.token, data)
            .then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
    })
}